import CanvasEditorDisplay from "./CanvasEditorDisplay.jsx";

const EditorDisplay = ({
  animation,
  assets,
  currentScriptText,
  onInsertMarkerTime,
  onInsertScriptSnippet,
  location,
  isLocationPicking = false,
  onLocationInputChange,
  onToggleLocationPicking,
  onLocationPick,
  onCancelLocationPick,
  toolCamera,
  isCameraOverrideActive,
  onCameraInputChange,
  onSyncCameraToLive,
  onResetCameraOverride,
  cameraOverride,
  onCameraStateChange,
}) => {
  return (
    <div className="animation-workbench-display-shell">
      <CanvasEditorDisplay
        animation={animation}
        assets={assets}
        currentScriptText={currentScriptText}
        onInsertMarkerTime={onInsertMarkerTime}
        onInsertScriptSnippet={onInsertScriptSnippet}
        location={location}
        showComponentBar={false}
        showTimelines={false}
        isLocationPicking={isLocationPicking}
        onLocationInputChange={onLocationInputChange}
        onToggleLocationPicking={onToggleLocationPicking}
        onLocationPick={onLocationPick}
        onCancelLocationPick={onCancelLocationPick}
        toolCamera={toolCamera}
        isCameraOverrideActive={isCameraOverrideActive}
        onCameraInputChange={onCameraInputChange}
        onSyncCameraToLive={onSyncCameraToLive}
        onResetCameraOverride={onResetCameraOverride}
        cameraOverride={cameraOverride}
        onCameraStateChange={onCameraStateChange}
      />
    </div>
  );
};

export default EditorDisplay;
